/**
 * Created with IntelliJ IDEA.
 * User: livnato
 * Date: 1/8/14
 * Time: 3:38 PM
 * To change this template use File | Settings | File Templates.

 * **********************************************************************************************************
 *
 * Options:
 * +  currentPageNumber
 * +  totalPagesNumber
 *
 * Public methods:
 * +  setInfo
 *
 * This widget is used to implement a paging  component on the page.
 * Options:
 * setCurrentPageNumber - current visible page.  optional: default is 1.
 * setTotalPagesNumber - total pages optional: default is 1.
 * blockWrongPageNumber - default is false  true uppon enter will return to previous value
 * pageType - default is "page"  choose page type page or item ( currently this changes the paging component text )
 * ignoreGridNumberOfItems - by default it is false for show the number of items that have or selected on the grid, by set it to true it will hide this indicator.
 * collection - REQUIRED as long as ignoreGridNumberOfItems isn"t true. This option is the Grid collection.
 *
 * *******************************************************************************************************/
define(function (require) {

    "use strict";
    var _ = require("underscore");
    var Marionette = require("marionette");
    var template = require("ui/paging/templates/paging.tmpl");
    var PagingModel = require("ui/paging/js/models/PagingModel");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var Logger = require("logger");
    var Translator = require("i18n/translator");

    var MINIMUM_PAGES_TO_SHOW = 2;
    var PAGE_TYPE = {
        PAGE: "page",
        ITEM: "item"
    };

    var Paging = Marionette.ItemView.extend({
        template: template,
        model: null,
        ui: {
            paging: ".paging",
            pagingPageNumberInput: ".paging-page",
            pagingPrevButton: ".paging-prev",
            pagingNextButton: ".paging-next",
            totalPages: ".num-pages",

//          Grid Selected Items      //
            gridNumberOfItems: ".grid-number-of-items",
            startIndex: ".grid-number-of-items .start-index",
            endIndex: ".grid-number-of-items .end-index",
            total: ".grid-number-of-items .total",
            itemsSelectedContainer: ".grid-number-of-items .items-selected-container",
            itemsSelected: ".grid-number-of-items .items-selected-container .items-selected",
            clearSelection: ".grid-number-of-items .clear-selection"
        },
        uiComponents: {
            pagingPageNumberInputField: {
                type: InputField,
                options: {
                    el: "view.ui.pagingPageNumberInput",
                    value: 1,
                    tabindex: 1,
                    "inputType": InputField.prototype.InputTypeEnum.NaturalNumber,
                    permutation: InputField.Permutation.J2,
                    disabled: false,
                    errorAlign: InputField.ERROR_ALIGN.LEFT
                },
                events: {
                    enterPressed: "_onEnter",
                    onblur: "_onBlur"
                }
            },
            pagingPrevButton: {
                type: Button,
                options: {
                    el: "view.ui.pagingPrevButton",
                    permutation: Button.PERMUTATION.BTN_PREV,
                    initState: Button.STATES.ENABLED
                },
                events: {
                    click: "_onPaginationPrevButtonClicked"
                }
            },
            pagingNextButton: {
                type: Button,
                options: {
                    el: "view.ui.pagingNextButton",
                    permutation: Button.PERMUTATION.BTN_NEXT,
                    initState: Button.STATES.ENABLED
                },
                events: {
                    click: "_onPaginationNextButtonClicked"
                }
            },
            clearSelection: {
                type: Button,
                options: {
                    el: "view.ui.clearSelection",
                    permutation: Button.PERMUTATION.BLUELINK,
                    text: Translator.translate("LEUIComponents.paging.clearAllSelected.text")
                },
                events: {
                    click: "_onClearSelectionClick"
                }
            }
        },

        initialize: function (options) {
            this._initialize(options);
        },

        onRender: function () {
            this._onRender();
        },
//PUBLIC

        setInfo: function (pageNumber, totalPagesNumber) {
            this._setInfo(pageNumber, totalPagesNumber);
        },

        setShowGridNumberOfItems: function (hideNumberOfItems) {
            this._setShowGridNumberOfItems(hideNumberOfItems);
        },

        setShowItemsSelectedContainer: function (hideItemsSelected) {
            this._setShowItemsSelectedContainer(hideItemsSelected);
        },

        setShowClearSelection: function (showClearSelection) {
            this._setShowClearSelection(showClearSelection);
        },

        setCollection: function (newCollection) {
            this._setCollection(newCollection);
        },

//PRIVATE
        _initialize: function (options){
            this.logger = Logger.getLogger("Paging");
            this.logger.debug("Initializing Paging", "Paging:initialize", {options: options});
            options = options || {} ;
            ///
            this.isServerHandling = options.isServerHandling || false;
            this._initPaging(options);
            this._initGridNumberOfItems(options);

        },

        _initPaging: function (options) {
            this.logger.debug("Initializing Paging", "Paging:initialize", {options: options});
            this.blockWrongPageNumber = _.isUndefined(options.blockWrongPageNumber)? false : options.blockWrongPageNumber;
            options.pageType =  _.isUndefined(options.pageType)? PAGE_TYPE.PAGE : options.pageType;

            this.model = new PagingModel({pageType: options.pageType});
            if (this.isServerHandling) {
                this.model.setCurrentPageNumber(this.collection.getPage());
                this.model.setTotalPagesNumber(this.collection.getTotalPages());
            }
        },

        _initGridNumberOfItems: function (options) {
            this.logger.debug("Initializing NumberOfItems in method _initGridNumberOfItems  at Paging ", "Paging:_initGridNumberOfItems", {options: options});
            this.collection = options.collection; // REQUIRED for get pageing data
            this.ignoreGridNumberOfItems = _.has(options, "ignoreGridNumberOfItems") ? options.ignoreGridNumberOfItems : false;
            this.showGridNumberOfItems = _.has(options, "showGridNumberOfItems")? options.showGridNumberOfItems : true;
            this.showItemsSelectedContainer = _.has(options, "showItemsSelectedContainer")? options.showItemsSelectedContainer : true;
            this.showClearSelection = _.has(options, "showClearSelection")? options.showClearSelection : false;
//          We check if collection is instance of organized collection by check method (that will be use later) that is part of organized collection.
            if (this.collection && (!_.isFunction(this.collection.getOriginalCollection) && !this.isServerHandling)) {
                this.logger.debug("Initializing NumberOfItems options.collection must be an organized collection or handled by the server", "Paging:_initGridNumberOfItems", {options: options});
                throw new Error("Initializing NumberOfItems in Paging Component - options.collection must be an organized collection");
            }
        },

        _onRender: function () {
            this.logger.debug("Rendering Paging", "Paging:_onRender");
            this.isRendered = true;
            this._bindEvents();
            this._onPagingRender();
            this._onGridNumberOfItemsRender();
        },

        _onPagingRender: function () {
            if (this.model.getTotalPagesNumber() >= MINIMUM_PAGES_TO_SHOW) {
                this._changeNextButtonState();
                this._changePrevButtonState();
                this._changeInputFieldState();
                this.ui.totalPages.text(this.model.getTotalPagesNumber());
            } else {
                this.ui.paging.addClass("hide");
            }
        },

        _onGridNumberOfItemsRender: function () {
            if (!this.ignoreGridNumberOfItems && this.collection) {
                this._parseNumberOfItemsText();
            }else{
                this._displayGridNumberOfItems(false);
            }
            if (!this.isServerHandling) {
                this._displayClearSelection(true);
            }
        },

        _bindEvents: function () {
            this._pagingBindEvents();
            this._gridNumberOfItemsBindEvents();
        },
        _unbindEvents: function() {
            if (this.collection) {
                this.stopListening(this.collection);
            }
            if (this.model) {
                this.stopListening(this.model, "change:currentPageNumber");
                this.stopListening(this.model, "change:totalPagesNumber");
            }
        },

        _pagingBindEvents: function () {
            this.listenTo(this.model, "change:currentPageNumber", this._currentPageNumberChange);
            this.listenTo(this.model, "change:totalPagesNumber", this._totalPagesNumberChange);
        },

        _gridNumberOfItemsBindEvents: function () {
            if (!this.ignoreGridNumberOfItems && this.collection) {
                if (this.isServerHandling) {
                    this.listenTo(this.collection, "change:selection fetch:success fetch:error", this._onServerHandlingFetch);
                }
                else {
                    this.listenTo(this.collection, "change:selection reset", this._parseNumberOfItemsText);
                }
            }
        },

        _onServerHandlingFetch: function() {
            // Tomer: This need to be in defer because it's triggered before the success callback so we don't have the data on the collection if we don't defer it (as the data on the collection arrived in the success callback)
            _.defer(_.bind(function() {
                if (this.collection.getPage() > this.collection.getTotalPages() && this.collection.getTotalPages() > 0) {
                    this.collection.setPage(this.collection.getTotalPages());
                }
                else {
                    this._parseNumberOfItemsText();
                    this._setInfo(this.collection.getPage(), this.collection.getTotalPages());
                }
            }, this));
        },

        _setInfo: function (pageNumber, totalPagesNumber) {
            this.model.setCurrentPageNumber(pageNumber);
            this.model.setTotalPagesNumber(totalPagesNumber);
        },

        _setCollection: function (newCollection) {
            //clear current listeners as set collection activates binding again.
            this._unbindEvents();
            this.collection = newCollection;
            this._onRender();
        },

        _currentPageNumberChange: function () {
            if (this.isRendered) {
                this._changeInputFieldState();
                this._changeNextButtonState();
                this._changePrevButtonState();
            }
        },

        _totalPagesNumberChange: function () {
            var showPaging = this.model.getTotalPagesNumber() >= MINIMUM_PAGES_TO_SHOW;
            if (this.isRendered) {
                if(showPaging){
                    this._currentPageNumberChange();
                    this.ui.totalPages.text(this.model.getTotalPagesNumber());
                }
                this.ui.paging.toggleClass("hide",!showPaging);
            }
        },

        _changeInputFieldState: function () {
            this.uiComponents.pagingPageNumberInputField.setValue(this.model.getCurrentPageNumber());
        },

        _onBlur: function () {
            this._changeInputFieldState();
        },

        _onEnter: function (name, id, data) {
            var currPageNum = parseInt(this.uiComponents.pagingPageNumberInputField.getValue(), 10);
            // check if parsing failed
            if (!_.isNaN(currPageNum) && (!this.blockWrongPageNumber || this.blockWrongPageNumber && currPageNum <= this.model.getTotalPagesNumber())) {
                // if value is not numeric - reset to 0 - and update view
                this.model.setCurrentPageNumber(currPageNum);
                this._changeNextButtonState();
                this._changePrevButtonState();
                this.trigger(Paging.TRIGGERING.PAGE_CHANGE, this.model.getCurrentPageNumber());
            } else {
                this._changeInputFieldState();
            }

        },

        _changeNextButtonState: function () {
            if (this.model.getCurrentPageNumber() === this.model.getTotalPagesNumber()) {
                this.uiComponents.pagingNextButton.setState(Button.STATES.DISABLED);
            }
            if (this.model.getTotalPagesNumber() > 1) {
                this.uiComponents.pagingPrevButton.setState(Button.STATES.ENABLED);
            }
        },

        _changePrevButtonState: function () {
            if (this.model.getCurrentPageNumber() === 1) {
                this.uiComponents.pagingPrevButton.setState(Button.STATES.DISABLED);
            }
            if (this.model.getTotalPagesNumber() > 1 && (this.model.getCurrentPageNumber() != this.model.getTotalPagesNumber())) {
                this.uiComponents.pagingNextButton.setState(Button.STATES.ENABLED);
            }
        },

        _onPaginationNextButtonClicked: function () {
            this.model.setCurrentPageNumber(this.model.getCurrentPageNumber() + 1);
            this._changeNextButtonState();
            this.trigger(Paging.TRIGGERING.PAGE_CHANGE, this.model.getCurrentPageNumber());
        },

        _onPaginationPrevButtonClicked: function () {
            this.model.setCurrentPageNumber(this.model.getCurrentPageNumber() - 1);
            this._changePrevButtonState();
            this.trigger(Paging.TRIGGERING.PAGE_CHANGE, this.model.getCurrentPageNumber());
        },

        _parseNumberOfItemsText: function() {
            this.logger.debug("Parsing NumberOfItems Text method _parseNumberOfItemsText in Paging " , "Paging:_parseNumberOfItemsText");

            var isItemsSelected = (this.collection && _.isFunction(this.collection.getSelectionLength)) ? !!this.collection.getSelectionLength() : false;
            var calculateItemsInPage = this._calculateItemsInPage();
            /**
             * showNumberOfItems will be false (will be hide) only if no items selected and there is no items on the page,
             * so the startIndex will be zero. when there is one item or more the startIndex will be one or more.
             **/
            var showNumberOfItems = calculateItemsInPage.startIndex !== 0 || isItemsSelected;

            this.ui.startIndex.text(calculateItemsInPage.startIndex);
            this.ui.endIndex.text(calculateItemsInPage.endIndex);
            this.ui.total.text(calculateItemsInPage.total);

            this.ui.itemsSelected.text(calculateItemsInPage.itemsSelected);
            this._displayGridNumberOfItems(showNumberOfItems);
            this._displayItemsSelectedContainer(isItemsSelected);
            this._displayClearSelection(isItemsSelected);
        },

        _setShowGridNumberOfItems: function (showNumberOfItems) {
            this.showGridNumberOfItems = showNumberOfItems;
            this._displayGridNumberOfItems();
        },

        _displayGridNumberOfItems: function (showNumberOfItems) {
            this.ui.gridNumberOfItems.toggleClass("hide", !(this.showGridNumberOfItems && showNumberOfItems));
        },

        _setShowItemsSelectedContainer: function (showItemsSelected) {
            this.showItemsSelectedContainer = showItemsSelected;
            this._displayItemsSelectedContainer();
        },

        _displayItemsSelectedContainer: function (showItemsSelected) {
            this.ui.itemsSelectedContainer.toggleClass("hide", !(this.showItemsSelectedContainer && showItemsSelected));
        },

        _setShowClearSelection: function (showClearSelection) {
            this.showClearSelection = showClearSelection;
            this._displayClearSelection();
        },

        _displayClearSelection: function (showClearSelection) {
            this.ui.clearSelection.toggleClass("hide", !(this.showClearSelection && showClearSelection));
        },


        _calculateItemsInPage: function () {
            var currentPage, pageSize, pageInfo, startIndex, endIndex, itemsSelected, totalItems;

            if (this.isServerHandling) {
                currentPage = this.collection.getPage();
                pageSize = this.collection.getPageSize();
                totalItems = this.collection.getTotalItems();
                startIndex = totalItems === 0 ? 0 : _.max([(pageSize * (currentPage - 1) + 1), 0]);
            }
            else {
                pageInfo = this.collection.getPagerInfo();
                currentPage = pageInfo.currentPageNumber;
                pageSize = pageInfo.pageSize;
                totalItems = pageInfo.totalItems;
                startIndex = _.max([(pageSize * (currentPage - 1) + 1), 0]);
            }

            endIndex = _.min([pageSize * currentPage, totalItems]);
            itemsSelected = (this.collection && _.isFunction(this.collection.getSelectionLength)) ? this.collection.getSelectionLength() : 0;

            return {
                startIndex: startIndex,
                endIndex: endIndex,
                itemsSelected: itemsSelected,
                total: totalItems
            };
        },

        _onClearSelectionClick: function (event) {
            var collection = (this.isServerHandling) ? this.collection : this.collection.getOriginalCollection();
            var allSelectedItems = collection.getSelected();
            this.trigger("clearSelection", allSelectedItems);
        }
    });
    Paging.TRIGGERING = {
        PAGE_CHANGE: "change:page"
    };
    Paging.PAGE_TYPE = PAGE_TYPE;

    return Paging;
});

